import { AlertCard, IconWrapper } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { InfosCard } from "@components/InfosCard/InfosCard";
import { useTenant } from "@contexts/Tenant/Tenant.context";
import { Elec, Gas } from "@icons";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./OverviewConsumption.module.css";
import type { OverviewConsumptionProps } from "./OverviewConsumption.types";

export const OverviewConsumption: FC<OverviewConsumptionProps> = ({
  gas,
  elec,
  isLoading,
}) => {
  const { t } = useCustomTranslation("main");
  const { authorizedEnergyType } = useTenant();
  const error = gas.isError && elec.isError;
  const isGasErrorDiplayed = gas.isError && authorizedEnergyType === "elec";
  const isElecErrorDiplayed = elec.isError && authorizedEnergyType === "gas";

  if (error || isGasErrorDiplayed || isElecErrorDiplayed) {
    return (
      <AlertCard className={classes.alertCard} variant="warning">
        {t("perimeter.unavailableConsumptionData")}
      </AlertCard>
    );
  }

  return (
    <>
      {!elec.isError && authorizedEnergyType !== "gas" && (
        <InfosCard
          data={elec.data}
          dataTestId="OverviewConso-Elec"
          icon={<IconWrapper role="presentation" size="md" src={Elec} />}
          loading={isLoading}
          title={t("perimeter.overview.energyConsumption.ELEC")}
        />
      )}

      {!gas.isError && authorizedEnergyType !== "elec" && (
        <InfosCard
          data={gas.data}
          dataTestId="OverviewConso-Gas"
          icon={<IconWrapper role="presentation" size="md" src={Gas} />}
          loading={isLoading}
          title={t("perimeter.overview.energyConsumption.GAS")}
        />
      )}
    </>
  );
};
